import { useBlueYonderLocations } from "@redotech/redo-customer-portal-shared/hooks/useBlueYonderLocations/use-blue-yonder-locations";
import { T, useTranslation } from "@redotech/redo-i18n";
import MarkerPin01Svg from "@redotech/redo-icons/marker-pin-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { InteractiveMap } from "./in-store-locations";

const BlueYonderLocationsModal = memo(function BlueYonderLocationsModal({
  draftReturnId,
  returnId,
}: {
  draftReturnId?: string;
  returnId?: string;
}) {
  const { locationsLoad } = useBlueYonderLocations(draftReturnId, returnId);

  if (locationsLoad.pending) {
    return <LoadingRedoAnimation />;
  }
  if (locationsLoad.error) {
    return (
      <Text textColor="error">
        <T>Error loading FedEx Easy Returns locations</T>
      </Text>
    );
  }
  if (!locationsLoad.value) {
    return null;
  }

  return <InteractiveMap locations={locationsLoad.value} />;
});

export const BlueYonderLocationsButton = memo(
  function BlueYonderLocationsButton({
    draftReturnId,
    returnId,
    autoOpen = false,
  }: {
    draftReturnId?: string;
    returnId?: string;
    autoOpen?: boolean;
  }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(autoOpen);
    return (
      <Flex>
        <RedoButton
          hierarchy="secondary"
          IconLeading={() => <MarkerPin01Svg />}
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
          text={t("See available locations")}
        />
        <RedoModal
          isOpen={isOpen}
          onModalCloseRequested={() => setIsOpen(false)}
          title={t("Find FedEx Easy Returns drop-off locations")}
        >
          <BlueYonderLocationsModal
            draftReturnId={draftReturnId}
            returnId={returnId}
          />
        </RedoModal>
      </Flex>
    );
  },
);
